module.exports = __webpack_public_path__ + "img/cirL.b2847c63.png";